import { LazyModule } from 'owa-bundling';
import { registerModuleWithPerformanceObserver } from './registerModuleWithPerformanceObserver';

/**
 * This interface extends LazyModule from owa-bundling and overloads the
 * import method to capture performanceEntry associated with the bundle load.
 */
export default class LazyModuleWithPerfData<TModule> extends LazyModule<TModule> {
    constructor(
        private moduleName: string,
        importCallback: () => Promise<TModule>,
        runWhen?: (cb: () => void) => void,
        private runBeforeImport?: () => void
    ) {
        super(importCallback); //Removing runWhen as a param due to package update changes. runWhen is used only in mini-mail-compose-actions-mail index and mini-mail-reading-pane-view index and is null/ undefined in both cases.
    }

    public import(): Promise<TModule> {
        this.runBeforeImport?.();
        registerModuleWithPerformanceObserver(this.moduleName);
        return super.importModule(this.moduleName).then(module => module);
    }
}
